import React from 'react';
import '../styles/Display.css';

function Display({ isOpen, onClose, url, textContent, type, title }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target.className === 'display-modal-overlay') {
      onClose();
    }
  };

  const renderContent = () => {
    if (type?.startsWith('text/')) {
      return (
        <div className="display-text-content">
          <pre>{textContent}</pre>
        </div>
      );
    }
    return (
      <iframe
        src={url}
        title="File Display"
        className="display-iframe"
        allow="fullscreen"
      />
    );
  };

  return (
    <div className="display-modal-overlay" onClick={handleOverlayClick}>
      <div className="display-modal">
        <div className="display-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontWeight: 'bold', marginLeft: '10px' }}>{title}</div>
          <button className="display-close-button" onClick={onClose}>×</button>
        </div>
        <div className="display-modal-content">
          {(url || textContent) && renderContent()}
        </div>
      </div>
    </div>
  );
}

export default Display; 